const NotificationDot = () => (
    <div className="tjt-notification-dot rounded-full shadow-s s-bg-negative border-2 w-16 h-16 absolute -top-4 -right-4 z-10"></div>
);

export default NotificationDot;
